import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// PRODUCTION FIX: Handle unhandled promise rejections globally
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  // Prevent default behavior (which may crash the app)
  event.preventDefault();
});

// PRODUCTION FIX: Handle global errors
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
  // Prevent default behavior
  event.preventDefault();
});

// PRODUCTION FIX: Suppress console errors in production (optional - for cleaner UX)
if (process.env.NODE_ENV === 'production') {
  const originalError = console.error;
  console.error = (...args) => {
    // Still log internally but don't spam user console
    if (args[0]?.includes?.('Warning:') || args[0]?.includes?.('React')) {
      return; // Suppress React warnings in production
    }
    originalError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

